<div class="docsContainer" *transloco="let translate;">
    <ng-container *ngIf="documentList?.length; else hasNoDocs">
        <div class="documentsHeader">
            <div class="my-2 d-flex">
                <span class="documentHeaderText d-block text-left font-weight-bold ml-2" [textContent]="translate('Available Documents')"></span>
            </div>
        </div>
        <div class="docsList" stop-propagation>
            <div class="docsSearch px-3">
                <mat-form-field>
                    <mat-label *transloco="let translate">{{ translate('Search document') }}</mat-label>
                    <input matInput type="text" [(ngModel)]="docSearch" (keyup)='searchHelpDocuments()'>
                    <material-button
                                     matSuffix
                                     *ngIf="docSearch"
                                     buttonType="icon"
                                     size="medium"
                                     [titleText]="translate('Clear Search')"
                                     prefixIconType="material"
                                     [prefixIcon]="docSearch ? 'close' : 'search'"
                                     (buttonClicked)="clearSearch()">
                    </material-button>
                </mat-form-field>
            </div>
            <ng-container *ngIf="(documentList | FilterPipe: 'fileName' : docSearch) as result">
                <div class="docs">
                    <div class="helpdocumentReports d-flex justify-content-between align-items-center ml-0 mr-0" mat-menu-item *ngFor="let report of result; trackBy:docListTrakBy">
                        <span class="reportsText" stop-propagation [textContent]="report.fileName">
                        </span>
                        <span *ngIf="report?.fileUrl" class="d-flex justify-content-between" stop-propagation>
                            <mat-icon class="documentDownloadIcon" [title]="translate('Download') + ' ' + report.fileName" (click)="downloadHelpDocument.emit(report)">cloud_download</mat-icon>
                            <ng-container *ngIf="!isIE">
                                <mat-icon class="documentDownloadIcon" [title]="translate('View') + ' ' + report.fileName" (click)="viewHelpDocument.emit(report)">visibility</mat-icon>
                            </ng-container>
                        </span>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf='docSearch && noDocumentsList'>
                <div class="d-flex justify-content-center noRecords">
                    <span>No records found.</span>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #hasNoDocs>
        <div class="text-center noDocument" [hidden]="documentList === undefined">
            <span [textContent]="translate('Help document is not available for this service')"></span>
        </div>
        <div class="text-center noDocument" [hidden]="documentList !== undefined">
            <span [textContent]="translate('Loading Documents') + '...'"></span>
        </div>
    </ng-template>
</div>
